import React, { useState } from 'react';

import Statistic from './statistic';

interface StatisticConfig {
  title: string;
  type: 'chart' | 'value';
  value?: string | number | null;
  formatter?: (value: string | number | null) => string;
  pill?: {
    label?: string;
    color?: string;
    icon?: React.ReactNode;
  };
}

interface StatisticsProps {
  statistics: StatisticConfig[];
}

const Statistics: React.FC<StatisticsProps> = ({ statistics }) => {
  const [collapsed, setCollapsed] = useState<Record<number, boolean>>({});

  const handleToggleCollapse = (idx: number) => {
    setCollapsed((prev) => ({
      ...prev,
      [idx]: !prev[idx],
    }));
  };

  return (
    <div className="statistic-stack">
      {statistics.map((stat, idx) => (
        <Statistic
          key={stat.title}
          {...stat}
          collapsed={collapsed[idx] ?? false}
          onToggleCollapse={() => handleToggleCollapse(idx)}
        />
      ))}
    </div>
  );
};
export default Statistics;
